import { IPassportUrls } from './urls'

export class PassportService {
    constructor(private urls: IPassportUrls) {
    }
    get CaseTimeDetailUrl() {
        return this.urls.caseTimeDetail
    }
}
